module.exports = __webpack_public_path__ + "static/img/北京总部背景@2x.213df90.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/北京总部背景@2x.png
// module id = 2plD
// module chunks = 0